import { useTheme } from "@emotion/react";
import {
  Box,
  Button,
  Card,
  Dialog,
  DialogActions,
  Stack,
} from "@mui/material";
import React, { useState } from "react";
import ImagePreview from "./ImagePreview";
import ReplayIcon from "@mui/icons-material/Replay";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch } from "react-redux";
import { imageStudioActions } from "../../store/imageStudio";

export default function ImagePreviews({
  images,
  bucketName,
  previewSize = 100,
}) {
  const dispatch = useDispatch();
  const [preview, setPreview] = useState(null);

  if (!images || images.length === 0) {
    return null;
  }

  const handleRetry = () => {
    if (!preview) return;
    preview.uploadImage();
    setPreview(null);
  };

  const handleDelete = () => {
    if (!preview) return;
    dispatch(imageStudioActions.removeImage(preview.index));
    setPreview(null);
  };

  return (
    <Box
      sx={{
        display: "flex",
        overflowX: "auto",
        whiteSpace: "nowrap",
        gap: 2,
        padding: 2,
      }}
    >
      {images.map((image) => (
        <Card
          key={image.index}
          sx={{
            minWidth: 100,
            height: 100,
            flex: "0 0 auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "transparent",
            overflow: "hidden",
            boxShadow: "none",
          }}
        >
          <ImagePreview
            key={`image-preview-${image.index}`}
            image={image}
            bucketName={bucketName}
            setPreview={setPreview}
            previewSize={previewSize}
          />
        </Card>
      ))}
      {preview !== null && (
        <Dialog open={preview !== null} onClose={() => setPreview(null)}>
          <Stack justifyContent="center" alignItems="center" maxHeight="100%">
            <img
              src={preview.base64 || preview.imageUrl}
              alt="image-preview"
              style={{
                width: "100%",
                maxHeight: "80vh",
              }}
            />
          </Stack>
          <DialogActions>
            {preview.error && (
              <Button
                variant="contained"
                color="error"
                onClick={handleRetry}
                startIcon={<ReplayIcon />}
              >
                Retry
              </Button>
            )}
            {!preview.error && (preview.base64 || preview.imageUrl) && (
              <Button
                variant="contained"
                color="error"
                onClick={handleDelete}
                startIcon={<DeleteIcon />}
              >
                Delete
              </Button>
            )}
          </DialogActions>
        </Dialog>
      )}
    </Box>
  );
}
